import { Layout } from 'antd';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import BackdropHeader from '~/components/nav/BackdropHeader/BackdropHeader';
import SideHeader from '~/components/nav/SideHeader/SideHeader';
import AdDetails from '~/components/screens/AdDetails/AdDetails';
import AdsCatalogue from '~/components/screens/AdsCatalogue/AdsCatalogue';
import Conversations from '~/components/screens/Conversations/Conversations';
import Home from '~/components/screens/Home/Home';
import OrderDetails from '~/components/screens/OrderDetails/OrderDetails';
import OrdersCatalogue from '~/components/screens/OrdersCatalogue/OrdersCatalogue';
import TestPage from '~/components/screens/TestPage/TestPage';
import { RoutingUrl } from '~/helpers/general';
import { ACTIVE_MERCHANT_UPDATE, CLEAR_REDIRECT_URL } from '~/store/reducers/session';
import breakpoints from '~/styles/breakpoints.module.scss';

import './MainNavigator.scss';
import OnBoarding from './OnBoarding';

const { Content } = Layout;

const breakpointMobile = parseInt(breakpoints.mdMax.slice(0, -2));
const FOCUS_ROUTES = [RoutingUrl.adCreation(), RoutingUrl.adEdition([':product_id'])];

function useActivateMerchant() {
  const dispatch = useDispatch();
  let { search } = useLocation();
  if (search && search.includes('activateMerchant')) {
    const activateMerchant = search
      .slice(1)
      .split('&')
      .map((param) => param.split('='))
      .find((param) => param[0] === 'activateMerchant');
    if (activateMerchant && activateMerchant.length === 2) {
      const merchantId = activateMerchant[1];
      dispatch({
        type: ACTIVE_MERCHANT_UPDATE,
        payload: { merchant_id: merchantId },
      });
    }
  }
}

function useRedirectAfterLogin() {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectUrl = useSelector((state) => state.session.redirectUrl);

  useEffect(() => {
    if (redirectUrl) {
      dispatch({ type: CLEAR_REDIRECT_URL });
      history.replace(redirectUrl);
    }
  }, [redirectUrl, dispatch, history]);
}

function Redirections() {
  return (
    <>
      <Route path='*'>
        <Redirect to={RoutingUrl.home()} />
      </Route>
    </>
  );
}

export default function MainNavigator() {
  const panelRef = useRef(null);
  const match = useRouteMatch(FOCUS_ROUTES);
  const isFocus = match !== null && window.innerWidth <= breakpointMobile;
  useActivateMerchant();
  useRedirectAfterLogin();

  return (
    <>
      <OnBoarding />
      <Layout hasSider className='layout-main-navigator-block'>
        <SideHeader />
        <Content>
          <BackdropHeader>
            <div className={`panel shadow-primary full-size-panel overflow-hidden${isFocus ? ' focused' : ''} min-h-full`}>
              <div className='inner-panel' ref={panelRef}>
                <Switch>
                  <Route exact path={RoutingUrl.home()} component={Home} />
                  <Route exact path={RoutingUrl.catalogue()} component={AdsCatalogue} />
                  <Route
                    exact
                    path={[RoutingUrl.adCreation(), RoutingUrl.adEdition([':product_id'])]}
                    render={(routeProps) => <AdDetails {...routeProps} isFocus={isFocus} panelRef={panelRef} />}
                  />
                  <Route exact path={RoutingUrl.orders()} render={(routeProps) => <OrdersCatalogue {...routeProps} panelRef={panelRef} />} />
                  <Route exact path={RoutingUrl.orderDetails([':order_id'])} render={(routeProps) => <OrderDetails {...routeProps} panelRef={panelRef} />} />
                  <Route exact path={RoutingUrl.conversations()} render={(routeProps) => <Conversations {...routeProps} panelRef={panelRef} />} />
                  <Route exact path='/testing' component={TestPage} />
                  <Redirections />
                </Switch>
              </div>
            </div>
          </BackdropHeader>
        </Content>
      </Layout>
    </>
  );
}
